import zod from 'zod';

export const BotHardwareEquipmentType = zod.enum([
  'robot',
  'gripper',
  'camera',
  'force_sensor',
]);
export type BotHardwareEquipmentType = zod.infer<
  typeof BotHardwareEquipmentType
>;

export const BotHardware = zod.object({
  id: zod.string(),
  name: zod.string(),
  equipmentType: BotHardwareEquipmentType,
  dataType: zod.string(),
  metadata: zod.any().nullable(),
  archived: zod.boolean().default(false),
  created: zod.date(),
});
export type BotHardware = zod.infer<typeof BotHardware>;

export const HardwareConfigSchema = zod.object({
  robots: zod.record(
    zod.string(),
    zod.object({
      isPrimary: zod.boolean(),
      hardware: zod.record(
        zod.string(),
        zod.object({
          id: zod.string(),
        }),
      ),
    }),
  ),
});
export type HardwareConfigSchema = zod.infer<typeof HardwareConfigSchema>;

export const HardwareConfigEquipmentMapping = zod.record(
  zod.string(),
  zod.object({
    robotId: zod.string().optional(), // only required for non-primary robots
    robotEquipmentId: zod.string().optional(), // only required for non-primary robots
    hardwareKeyToEquipmentId: zod.record(zod.string(), zod.string()),
  }),
);
export type HardwareConfigEquipmentMapping = zod.infer<
  typeof HardwareConfigEquipmentMapping
>;

export const HydratedHardwareConfigSchema = zod.object({
  robots: zod.record(
    zod.string(),
    zod.object({
      isPrimary: zod.boolean(),
      hardware: zod.record(zod.string(), BotHardware),
    }),
  ),
});
export type HydratedHardwareConfigSchema = zod.infer<
  typeof HydratedHardwareConfigSchema
>;
